import Option from "@p-ban/common/src/components/form/SelectBox/Option"
import Select from "@p-ban/common/src/components/form/SelectBox/Select"
import { range } from "@p-ban/common/src/utils/NumberUtils"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisabledCondition from "../../../../../service/getDisabledCondition"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import { resolveRouterCutKindName } from "../../../../../service/impositionNameResolver/impositionNameResolver"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./routerCut.png"

const ルーター切り出し面付け = ({ values, handlers, errors }: OneClickFieldProps) => {
  const condition = getDisplayCondition(values)
  const disabled = getDisabledCondition(values)
  const shouldShow = condition.routerCut || condition.routerCutKind

  return (
    <OneClickField
      isShow={shouldShow}
      legend={"ルーター切り出し\n面付け"}
      helpURL={HELP_LINKS.ルーター切り出し面付け}
      src={img}
    >
      <OneClickFieldStack>
        <Select
          name={FIELD_NAMES["ルーター切り出し面付け 面付け数"]}
          value={values.routerCut}
          onChange={handlers.select}
          aria-label="面付け数"
        >
          {Object.values(ESTIMATE_CONSTANT["ルーター切り出し面付け 面付け数"]).map(({ name, value }) => (
            <Option key={value} value={value}>
              {name}
            </Option>
          ))}
        </Select>
        <Select
          name={FIELD_NAMES["ルーター切り出し面付け 種類"]}
          value={values.routerCutKind ?? ""}
          onChange={handlers.selectAsNumber}
          disabled={disabled.routerCutKind}
          aria-label="種類"
        >
          <Option value="">選択してください</Option>
          {[...range(1, 31)].map((value) => (
            <Option key={value} value={value}>
              {resolveRouterCutKindName(value)}
            </Option>
          ))}
        </Select>
      </OneClickFieldStack>
      <OneClickFieldMessages error={errors?.routerCut} />
      <OneClickFieldMessages error={errors?.routerCutKind} />
    </OneClickField>
  )
}

export default ルーター切り出し面付け
